import useSWR, { KeyedMutator } from 'swr';
import { SWRFetcher } from '@commenda/utils';

export default function useSearchSummarizedInvoices(
  corporationIds: number[],
  token: string,
  effectiveStartDate?: Date,
  effectiveEndDate?: Date,
  isCorruptedAtSource?: boolean
): {
  data: { invoices: number };
  error: unknown;
  mutate: KeyedMutator<unknown>;
} {
  const query = new URLSearchParams();

  query.append('corporationIds', corporationIds.toString());

  if (effectiveStartDate)
    query.append('effectiveStartDate', effectiveStartDate?.toISOString());

  if (effectiveEndDate)
    query.append('effectiveEndDate', effectiveEndDate?.toISOString());

  if (isCorruptedAtSource !== null && isCorruptedAtSource !== undefined) {
    query.append('isCorruptedAtSource', isCorruptedAtSource ? 'true' : 'false');
  }

  const {
    data,
    error,
    mutate,
  }: {
    mutate: KeyedMutator<unknown>;
    error: unknown;
    data: { invoices: number };
  } = useSWR(
    `integrations/data/accounting/invoices/search?${query}`,
    SWRFetcher({ method: 'GET' }, token)
  );

  return {
    data,
    error,
    mutate,
  };
}
